import React, {  } from "react";
import { useSelector } from "react-redux";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import { useTranslation } from "react-i18next";
import { Box, Tooltip, Typography } from "@mui/material";
const MixedLettersMobileHints = () => {
  const { t } = useTranslation();
  const answer = useSelector(selectAnswer);

  return (
    <Tooltip followCursor title={t("QUESTIONS.FORM.LABELS.MOBILE_TOOLTIP_HINT_TOOLTIP")}>
    <Box
      sx={{
        minHeight: '64px',
        marginTop: "16px",
        borderRadius: "4px",
        padding: "5px",
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        justifyContent: "left",
        gap: "8px",
        border: "1px solid #ccc",
      }}
    >
      {answer.mixed_letter?.map((item, index) => {
        const word = item?.word;

        return (
          <Typography key={index} fontWeight={500} fontSize={14}>
            {t("QUESTIONS.FORM.LABELS.MIXED_LETTER_MOBILE_HINT", {
              num: index + 1,
              word,
            })}
          </Typography>
        );
      })}
    </Box>
    </Tooltip>
  );
};

export default MixedLettersMobileHints;
